import React, { useContext } from 'react';
import { observer } from 'mobx-react-lite';
import {
  HrFlexContainer,
  HrTitleContainer,
  HrTitleH4,
  HrLabel,
  HrParagraph,
  HrRed
} from '@components/styles/hr-styles';
import { useTranslation } from 'react-i18next';
import { Textarea } from '@components/form/textarea';
import { RadioForm } from '@components/form/radio/radio';
import styled from 'styled-components';
import { ErrorMessage } from '@hookform/error-message';
import { DisplaySettingsContext } from '../../store/display-settings';

const FlexContainer = styled(HrFlexContainer)`
  padding: 0 32px;

  @media (max-width: 768px) {
    padding: 0 16px;
  }
`;

const type = {
  simple: 'simple',
  multiple: 'multiple'
};
export const Questions = observer(
  ({ action, formState, register, questions, control, setValue, postulant }) => {
    const [t] = useTranslation();
    if (action === 'edit' && postulant.showQuestions !== true) {
      return null;
    }
    const { errors } = formState;
    const { darkMode, fontSizeSetting } = useContext(DisplaySettingsContext);

    const questionSimpleHtml = (q, index) => {
      return (
        <>
          <Textarea
            placeholder={t('postulant.question.answer')}
            title={`${index + 1}. ${q.text}`}
            id={`answers.${index}.answer`}
            control={control}
            showCount={false}
            key={`${index}-answers.${index}.answer`}
            minHeight='150px'
            validate={{ required: true }}
            formState={formState}
            handlerOnBlur={(e) => {
              setValue(`answers.${index}.answer`, e.target.value.trim(), { shouldValidate: true });
            }}
          />
          <input
            type='hidden'
            {...register(`answers.${index}.question_text`)}
            defaultValue={q.text}
          />
          <input
            type='hidden'
            {...register(`answers.${index}.question_id`)}
            defaultValue={q._id?.$oid || q?.id}
          />
        </>
      );
    };
    // TODO: revisar que no vengas las respuesta descalificadoras
    const questionMultipleHtml = (q, index) => {
      return (
        <HrFlexContainer width='100%' key={`quest-${index}-answer`}>
          <HrFlexContainer justifyContent='space-between'>
            <HrLabel
              fontSizeSetting={fontSizeSetting}
              color={darkMode ? 'white' : ''}
              htmlFor='id'
              isRequired
              userSelect='none'
            >
              {`${index + 1}. ${q.text}`}
            </HrLabel>
          </HrFlexContainer>
          <ErrorMessage
            errors={errors}
            name={`answers.${index}.answer`}
            render={({ message }) => <HrParagraph color={HrRed}>{message}</HrParagraph>}
          />
          <HrFlexContainer gap='8px' width='100%' flexDirection='column' alignItems='flex-start'>
            {q.options.map((o) => {
              return (
                <>
                  <RadioForm
                    name={`answers.${index}.answer`}
                    text={o}
                    value={o}
                    register={register}
                    validate={{ required: true }}
                    control={control}
                    formState={formState}
                    checked={false}
                    setValue={setValue}
                    key={`RadioForm-${index}-answer`}
                  />
                </>
              );
            })}
          </HrFlexContainer>
          <input
            type='hidden'
            {...register(`answers.${index}.question_text`)}
            defaultValue={q.text}
          />
          <input
            type='hidden'
            {...register(`answers.${index}.question_id`)}
            defaultValue={q._id?.$oid || q?.id}
          />
        </HrFlexContainer>
      );
    };

    const htmlQuestions = questions?.map((q, index) => {
      if (q.type === type.simple) {
        return questionSimpleHtml(q, index);
      }
      if (q.type === type.multiple) {
        return questionMultipleHtml(q, index);
      }
      return '';
    });

    if (questions?.length === 0) {
      return null;
    }
    return (
      <HrFlexContainer flexDirection='column' alignItems='flex-start'>
        <HrTitleContainer borderBottom={darkMode ? '1px solid #767676' : ''}>
          <HrTitleH4 fontSizeSetting={fontSizeSetting} color={darkMode ? 'white' : ''}>
            {t('postulant.question.title')}
          </HrTitleH4>
        </HrTitleContainer>
        <FlexContainer justifyContent='space-between' padding='0 32px'>
          {htmlQuestions}
        </FlexContainer>
      </HrFlexContainer>
    );
  }
);
